/* /assets/oa-accessoire-block.js
   1) "Maak je strandset compleet" slider — gewone horizontale slider.
      - GEEN doorlopende loop/marquee meer: je scrollt en hij STOPT aan de randen.
      - Prev/next knoppen schuiven een 'pagina' op (smooth) en stoppen netjes bij begin/eind.
      - Native touch-scroll blijft gewoon werken.
   2) "Past perfect bij" + knop — voegt het product direct toe aan de winkelwagen
      en opent de cart-drawer (net als de winkelwagen-upsell), i.p.v. doorlinken. */
(function () {
  /* ── Strandset slider (geen loop, stopt aan randen) ───────────────── */
  function initTrack(track) {
    if (track.dataset.oaSetInit) return;
    track.dataset.oaSetInit = '1';
    if (track.children.length === 0) return;

    var setContainer = track.closest('.oa-pb__strandset');
    if (!setContainer) return;

    var btnPrev = setContainer.querySelector('[data-oa-strandset-prev]');
    var btnNext = setContainer.querySelector('[data-oa-strandset-next]');

    var nudge = function (dir) {
      var amount = Math.max(220, Math.round(track.clientWidth * 0.8));
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    };

    /* Knoppen dimmen/uitschakelen aan begin & eind zodat duidelijk is dat hij stopt */
    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= maxScroll - 2;
      var hasOverflow = maxScroll > 4;
      if (btnPrev) { btnPrev.disabled = atStart || !hasOverflow; }
      if (btnNext) { btnNext.disabled = atEnd || !hasOverflow; }
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { nudge(-1); });
    if (btnNext) btnNext.addEventListener('click', function () { nudge(1); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  /* ── "Past perfect bij" — direct toevoegen aan winkelwagen ────────── */
  function refreshCartUI() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
      document.querySelectorAll('[data-oa-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count);
        el.classList.toggle('is-hidden', cart.item_count === 0);
      });
      document.querySelectorAll('[data-header-cart-count], [data-oa-cart-count], [data-cart-count], .cart-count, .cart-count-bubble span').forEach(function (el) {
        if (!el.hasAttribute('data-oa-cart-count')) el.textContent = cart.item_count;
        el.classList.remove('oa-cart-just-bumped');
        void el.offsetWidth;
        el.classList.add('oa-cart-just-bumped');
      });
      /* Open de cart popup (oa-header-popups) automatisch */
      var cartTrigger = document.querySelector('[data-oa-popup="cart"]');
      if (cartTrigger) cartTrigger.click();
    });
  }

  function initPerfectAdd() {
    document.querySelectorAll('[data-oa-perfect-add]').forEach(function (btn) {
      if (btn.dataset.oaPerfectInit) return;
      btn.dataset.oaPerfectInit = '1';

      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-loading') || btn.disabled) return;
        var variantId = btn.dataset.variantId;
        if (!variantId) return;

        btn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (res) { if (!res.ok) throw new Error('Cart error'); return res.json(); })
          .then(function () { return refreshCartUI(); })
          .then(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-success');
            setTimeout(function () { btn.classList.remove('is-success'); }, 1800);
          })
          .catch(function () { btn.classList.remove('is-loading'); });
      });
    });
  }

  function init() {
    document.querySelectorAll('.oa-pb__strandset-track').forEach(initTrack);
    initPerfectAdd();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
